import { render, staticRenderFns } from "./govmtlogin.vue?vue&type=template&id=0b18e5a8&"
import script from "./govmtlogin.vue?vue&type=script&lang=js&"
export * from "./govmtlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports